import Loadable from "react-loadable";

export const BillingAndPayments = Loadable({
  loader: () => import("../../../modules/manage-pitch").then((module) => module.BillingAndPayments) as Promise<any>,
  loading: () => null,
});
